App.SettingsPaymentsController = Em.Controller.extend
  inappSupport: Em.inject.service('inappSupport')
  organizationBinding: 'model'

  validations: {}

  VALIDATABLE_FIELDS: [
    'accept_cashless'
  ]

  isSaving: false

  extractValidations: (model, fields) ->
    errors = model.get('errors')
    validations = {}

    fields.forEach (field) =>
      if errors.has(field)
        validations[field] = errors.errorsFor(field).map (m) ->
          m.message
        .join(',')

    errors.clear()
    validations

  actions:
    saveOrganization: ->
      @set('isSaving', true)

      organization = @get('organization')
      organization.save()
      .finally =>
        @set('isSaving', false)
        @set('validations', @extractValidations(organization, @VALIDATABLE_FIELDS))
        @get('organization').reload()
      false

    discartChanges: ->
      @get('organization').rollback()
      false

    askSupport: ->
      @get('inappSupport')?.initiateDialogue()
      false
